import { type CustomField, CustomFieldType } from '~/types';

export const getFallbackValue = (customField: CustomField) => {
  return customField.type === CustomFieldType.multiSelection ? [] : '';
};

export const sanitizeCustomFieldValue = (
  customField: CustomField,
  value: string | string[]
) => {
  if (customField.type === CustomFieldType.multiSelection) {
    if (Array.isArray(value)) {
      return value;
    }

    // Create an array out of the string in case the custom field
    // was previously defined as a different type which stores a string
    return [value];
  }

  if (Array.isArray(value)) {
    // Create a string out of the array in case the custom field
    // was previously defined as a multi-selection field
    return value.join(', ');
  }

  return value;
};
